require('./build/loading-bar');
require('./build/loading-bar.css');
module.exports = 'angular-loading-bar';



//////////////////
// WEBPACK FOOTER
// ./~/angular-loading-bar/index.js
// module id = 97
// module chunks = 0